module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/298ae8a399c243d130f66ea76feb8495.png";